<template>
<div class="container">
  <br>
  <iframe :src="source"></iframe>

</div>
</template>

<script>

export default {
  name: 'GProfile',

  components: {
  },

  created() {
  },

  mounted(){
  },

  data() {
    return {
      source: 'https://fontawesomeicons.com/fa/vue-js-open-url-as-modal-popup-with-overlay'
    }
  },

  computed: {
  },

  methods: {
  }
}
</script>

<style>
.iframe {
  height: 100vh;
  width: 100vw;
  border: none;
  box-sizing: border-box;
}

.loadingItem {
  align-items: center;
  justify-content: center;
  display: flex;
}

.action-panel {
  margin-bottom: 10px;
  margin-right: 5px;
}
</style>
